export function canSwitchMode(mode) {
    return true;
}
//# sourceMappingURL=view-mode.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/datepicker/engine/view-mode.js
// module id = 511
// module chunks = 3